const i18n = {
	headerItem: {
		1 : ["Задать вопрос администратору"],
		0 : ["Задаць пытанне адміністратару"]
	},
	labels: {
		1: [
			'Имя',
			'Адрес эл. почты',
			'Телефон',
			'Суть вопроса'
		],
		0: [
			'Імя',
			'Адрас эл. пошты',
			'Тэлефон',
			'Сутнасць пытання'
		]
	},
	placeholderText: {
		1: [
			'Ваше имя',
			'Ваш e-mail',
			'Ваш телефон',
			'Опишите Вашу проблему'
		],
		0: [
			'Ваша імя',
			'Ваш e-mail',
			'Ваш тэлефон',
			'Апішыце Вашу праблему'
		]
	},
	submitBtnText: {
		1 : 'Задать вопрос',
		0 : 'Задаць пытанне'
	},
	feedbackHeader: {
		1 : 'Обратная связь',
		0 : 'Зваротная сувязь'
	},
	validateMessages: {
		required: {
			1 : 'Данное поле  обязательно для заполнения',
			0 : 'Дадзенае поле абавязкова для запаўнення'
		},
		types: {
			email: {
				1 : 'Данное поле заполнено некорректно',
				0 : 'Дадзенае поле запоўнена некарэктна'
			}
		},
		addAppealFile:{
			1: 'Необходимо добавить файл с подписями',
			0: 'Неабходна дадаць файл з подпісамі',
		}
	},
	successNotification: {
		1 : 'Ваш вопрос успешно отправлен администратору системы.',
		0 : 'Ваша пытанне паспяхова адпраўлена адміністратару сістэмы.'
	},
	formItemsRules: {
		userName: {
			1 : 'Длина строки 2-100 символов.',
			0 : 'Даўжыня радка 2-100 знакаў.'
		},
		message: {
			1 : 'Длина строки 2-15000 символов.',
			0 : 'Даўжыня радка 2-15000 знакаў.'
		},
		userEmail: [
			{
				1 : 'Проверьте корректность введенных данных. Убедитесь, что адрес электронной почты указан в таком формате: example@email.com.',
				0 : 'Праверце карэктнасць уведзеных дадзеных. Пераканайцеся, што адрас электроннай пошты зазначаны ў такім фармаце: example@email.com.'
			},
			{
				1 : 'Длина строки 2-100 символов.',
				0 : 'Даўжыня радка 2-100 знакаў.'
			}
		],
		userPhoneNumber: [
			{
				1 : 'Длина строки 8-15 символов.',
				0 : 'Даўжыня радка 2-15 знакаў.'
			},
			{
				1 : 'Проверьте корректность введенных данных. Номер телефона должен соответствовать шаблону: + (при условии обязательного ввода символа «+»), (код страны) 1 – 3 цифры, (код города или сети) 2 – 5 цифры, (номер телефона) 5 – 7 цифр.',
				0 : 'Праверце карэктнасць уведзеных дадзеных. Нумар тэлефона павінен адпавядаць шаблоне: + (пры ўмове абавязковага ўводу сімвала «+»"), (код краіны) 1 – 3 лічбы, (код горада або сеткі) 2 – 5 лічбы, (нумар тэлефона) 5 – 7 лічбаў.'
			}
		]
	},
	formItemsErrors: {
		message: {
			1 : 'Введите вопрос.',
			0 : 'Увядзіце пытанне.'
		}
	}
}

export default i18n